import React, { useState } from 'react';
import { FadeIn } from '../components/FadeIn';
import { SendIcon } from 'lucide-react';
export function Contact() {
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  return <article data-id="element-283">
      {/* Hero */}
      <section className="pt-32 pb-16 md:pt-40 md:pb-20 bg-cognarch-white border-b border-cognarch-border" data-id="element-284">
        <div className="max-w-3xl mx-auto px-6" data-id="element-285">
          <FadeIn delay={0.1} direction="down" data-id="element-286">
            <p className="uppercase tracking-[0.25em] text-xs font-medium text-cognarch-gray mb-8" data-id="element-287">
              Get in Touch
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-288">
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif font-medium leading-[1.1] tracking-tight text-cognarch-black mb-8 text-balance" data-id="element-289">
              Contact
            </h1>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-290">
            <p className="text-lg md:text-xl text-cognarch-gray leading-relaxed max-w-2xl" data-id="element-291">
              For inquiries related to the Cognarchism project, its
              constitutional framework, academic collaboration, or institutional
              correspondence, use the form below.
            </p>
          </FadeIn>
        </div>
      </section>

      {/* Contact Form + Info */}
      <section className="py-20 md:py-28 bg-cognarch-white" data-id="element-292">
        <div className="max-w-5xl mx-auto px-6" data-id="element-293">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-16 md:gap-12" data-id="element-294">
            {/* Form */}
            <div className="md:col-span-7" data-id="element-295">
              <FadeIn data-id="element-296">
                {submitted ? <div className="py-16 text-center border border-cognarch-border bg-cognarch-offwhite" data-id="element-297">
                    <div className="w-12 h-px bg-cognarch-charcoal mx-auto mb-8" data-id="element-298" />
                    <h2 className="text-2xl font-serif text-cognarch-charcoal mb-4" data-id="element-299">
                      Message Received
                    </h2>
                    <p className="text-cognarch-gray text-base max-w-md mx-auto" data-id="element-300">
                      Thank you for your correspondence. Your inquiry has been
                      recorded and will be reviewed in due course.
                    </p>
                  </div> : <form onSubmit={handleSubmit} className="space-y-8" data-id="element-301">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-302">
                      <div data-id="element-303">
                        <label htmlFor="name" className="block text-xs uppercase tracking-widest text-cognarch-gray mb-3 font-medium" data-id="element-304">
                          Name
                        </label>
                        <input id="name" name="name" type="text" required className="w-full bg-transparent border-b border-cognarch-border py-3 text-cognarch-charcoal text-base placeholder:text-cognarch-border focus:border-cognarch-charcoal focus:outline-none transition-colors" placeholder="Full name" data-id="element-305" />
                      </div>
                      <div data-id="element-306">
                        <label htmlFor="email" className="block text-xs uppercase tracking-widest text-cognarch-gray mb-3 font-medium" data-id="element-307">
                          Email
                        </label>
                        <input id="email" name="email" type="email" required className="w-full bg-transparent border-b border-cognarch-border py-3 text-cognarch-charcoal text-base placeholder:text-cognarch-border focus:border-cognarch-charcoal focus:outline-none transition-colors" placeholder="Email address" data-id="element-308" />
                      </div>
                    </div>

                    <div data-id="element-309">
                      <label htmlFor="subject" className="block text-xs uppercase tracking-widest text-cognarch-gray mb-3 font-medium" data-id="element-310">
                        Subject
                      </label>
                      <input id="subject" name="subject" type="text" required className="w-full bg-transparent border-b border-cognarch-border py-3 text-cognarch-charcoal text-base placeholder:text-cognarch-border focus:border-cognarch-charcoal focus:outline-none transition-colors" placeholder="Subject of inquiry" data-id="element-311" />
                    </div>

                    <div data-id="element-312">
                      <label htmlFor="message" className="block text-xs uppercase tracking-widest text-cognarch-gray mb-3 font-medium" data-id="element-313">
                        Message
                      </label>
                      <textarea id="message" name="message" required rows={6} className="w-full bg-transparent border border-cognarch-border p-4 text-cognarch-charcoal text-base placeholder:text-cognarch-border focus:border-cognarch-charcoal focus:outline-none transition-colors resize-none" placeholder="Your message" data-id="element-314" />
                    </div>

                    <button type="submit" className="inline-flex items-center gap-3 px-8 py-4 bg-cognarch-black text-white font-medium tracking-wide hover:bg-cognarch-charcoal transition-all duration-300 text-sm" data-id="element-315">
                      Send Message
                      <SendIcon className="w-4 h-4" strokeWidth={1.5} data-id="element-316" />
                    </button>
                  </form>}
              </FadeIn>
            </div>

            {/* Sidebar Info */}
            <div className="md:col-span-5" data-id="element-317">
              <FadeIn delay={0.2} data-id="element-318">
                <div className="space-y-12" data-id="element-319">
                  <div data-id="element-320">
                    <h3 className="text-xs uppercase tracking-widest text-cognarch-gray mb-4 font-medium" data-id="element-321">
                      Correspondence
                    </h3>
                    <p className="text-cognarch-charcoal text-base leading-relaxed" data-id="element-322">
                      All inquiries are reviewed by the editorial and
                      institutional team. Response times may vary depending on
                      the nature and scope of the correspondence.
                    </p>
                  </div>

                  <div className="border-t border-cognarch-border pt-8" data-id="element-323">
                    <h3 className="text-xs uppercase tracking-widest text-cognarch-gray mb-4 font-medium" data-id="element-324">
                      Appropriate Inquiries
                    </h3>
                    <ul className="space-y-3" data-id="element-325">
                      {['Academic or research collaboration', 'Institutional partnership', 'Press and media inquiries', 'Constitutional framework discussion', 'General questions about the project'].map((item, i) => <li key={i} className="flex items-start gap-3 text-cognarch-gray text-sm" data-id="element-326">
                          <span className="text-cognarch-charcoal/30 text-xs mt-1" data-id="element-327">
                            ◆
                          </span>
                          {item}
                        </li>)}
                    </ul>
                  </div>

                  <div className="border-t border-cognarch-border pt-8" data-id="element-328">
                    <h3 className="text-xs uppercase tracking-widest text-cognarch-gray mb-4 font-medium" data-id="element-329">
                      Notice
                    </h3>
                    <p className="text-cognarch-gray text-sm leading-relaxed" data-id="element-330">
                      The Cognarchism Project does not accept unsolicited
                      political endorsements, campaign affiliations, or partisan
                      alignment requests.
                    </p>
                  </div>
                </div>
              </FadeIn>
            </div>
          </div>
        </div>
      </section>
    </article>;
}